export default __webpack_public_path__ + "static/media/info-light.9cdc1661.svg";